<template>
  <v-dialog
    :value="showForm"
    persistent
    max-width="400px"
  >
    <v-alert
      :value="true"
      color="black"
      outline
      style="background: white;"
      class="text-md-left px-3 black--text">
      <div>
        <div class="body text-md-left">出品票の作成</div>
        <v-divider
          class="mt-2 mb-5"
        />
        <v-flex
          class="my-3">
          <div
            class="body">
            <div class="mb-3">
              出品票を作成し、出品者に公開しますか？
            </div>
            <v-layout justify-end>
              <v-btn
                :loading="sending"
                class="mt-3"
                dark
                color="primary lighten-1"
                @click.native="sendRequest"
              >
                公開する
              </v-btn>
              <v-btn
                class="mt-3"
                dark
                outline
                color="red lighten-1"
                @click.native="close"
              >
                キャンセル
              </v-btn>
            </v-layout>
          </div>
        </v-flex>
      </div>
    </v-alert>
  </v-dialog>
</template>

<script>

export default {
  data() {
    return {
      requestSent: false,
      sending: false,
      errorMessage: null,
    };
  },
  computed: {
    showForm() {
      return this.$store.state.showSendShuppinhyoDialog;
    },
  },
  methods: {
    sendRequest() {
      this.sending = true;

      this.updateAppointment({ field: 'sentShuppinhyoFlag', value: '1' })
        .then(resp => this.success(resp))
        .catch(e => this.error(e));
    },
    success() {
      this.requestSent = true;
      this.sending = false;

      this.$store.commit('toggleSentShuppinhyoDialog');
    },
    error({ status }) {
      this.requestSent = false;
      this.sending = false;

      this.errorMessage = status.error_message;
    },
    close() {
      this.$store.commit('toggleSentShuppinhyoDialog');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ShuppinhyoDialog.vue